export const transmissionTypes = [
  'Manual',
  'Automatic',
  'Semi-Automatic',
  'CVT',
  'Dual Clutch',
];
